import React from 'react';
import PropTypes from 'prop-types';

export default function Tick({ size }) {
  const classes = 'display-block';

  if (size === 'extraSmall' || size === 'small') {
    return (
      <svg className={classes} width="12" height="10" viewBox="0 0 12 10">
        <path d="M3,9.63.45,7a2,2,0,0,1,0-2.52h0a1.46,1.46,0,0,1,2.12-.1.1.1,0,0,1,.1.1L4,6,9.33.47a1.58,1.58,0,0,1,2.22,0h0a1.58,1.58,0,0,1,0,2.22l-6.86,7A1.16,1.16,0,0,1,3,9.63H3" />
      </svg>
    );
  } else if (size === 'extraLarge') {
    return (
      <svg className={classes} width="22" height="18" viewBox="0 0 22 18">
        <path d="M5.62,17.35.86,12.57a3.37,3.37,0,0,1,0-4.5h0a2.8,2.8,0,0,1,3.95-.23L5,8.07l2.32,2.72,9.79-10a2.88,2.88,0,0,1,4,0h0a2.83,2.83,0,0,1,0,4L8.81,17.35a2.27,2.27,0,0,1-3.19,0" />
      </svg>
    );
  }

  return (
    <svg className={classes} width="18" height="13.99" viewBox="0 0 18 13.99">
      <path d="M4.57,13.49.69,9.79a2.52,2.52,0,0,1,0-3.49h0A2.35,2.35,0,0,1,4,6.23l.07.07L6,8,14,.65a2.43,2.43,0,0,1,3.3,0h0a2.12,2.12,0,0,1,.12,3l-.12.12L7.16,13.49a1.91,1.91,0,0,1-2.59,0" />
    </svg>
  );
}

Tick.propTypes = {
  size: PropTypes.string,
};

Tick.defaultProps = {
  size: 'medium',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-button/icons/Tick.js